import { render, staticRenderFns } from "./BrandReset.vue?vue&type=template&id=127c8fd9&scoped=true"
import script from "./BrandReset.vue?vue&type=script&lang=js"
export * from "./BrandReset.vue?vue&type=script&lang=js"
import style0 from "./BrandReset.vue?vue&type=style&index=0&id=127c8fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127c8fd9",
  null
  
)

export default component.exports